const opportunitiesData = [
    {
        img: './Images/Opportunities1.png',
        name: 'All NGOS have a fascinating story to tell.',
        content: '​SVP Fast Pitch helps them tell it and offers donors a chance to be a part of collective action that leads to a bigger change!',
        icon: 'ti-arrow-right',
        linkTitle: "REGISTER",
        anchor: "https://lu.ma/fastpitch2025",
        title:'OFFERS'

    },
    {
        img: './Images/Opportunities2.png',
        name: 'School to School “Khushiyon” Ka Recycle',
        content: 'Do you want to share your child’s pre-loved school supplies to nudge joyful learning in remote schools? \n\n You can contribute notebooks, stationery, sports material, uniforms, shoes, games, toys and more!',
        icon: 'ti-arrow-right',
        linkTitle: "CONTRIBUTE",
        link: "/GSN-276/GOONJ",
        title:'ASKS',
        id:'involved'
    },
    {
        img: './Images/Opportunities3.png',
        name: 'April is World Autism Month!',
        content: 'Action for Autism invites you to visit their Art exhibition: Views from Planet Autism 2025.\n\n Date 27-30 April, 2025, from 10 am- 8 pm at Open Palm Court Gallery, India Habitat Centre, Lodhi Road, New Delhi',
        icon: 'ti-arrow-right',
        linkTitle: "Participate",
        link: "/GSN-1062/AFA",
        title:'EVENTS',
        id:'involved'
    },
    {
        img: './Images/Opportunities4.png',
        name: 'Validity period for FCRA Prior Permission',
        content: 'MHA announced on 7th April, 2025 validity period for receipt (3 years) and utilisation (4 years) from the date of approval of the application for prior permission of foreign contributions.',
        icon: 'ti-arrow-right',
        linkTitle: "Learn more",
        anchor: "https://fcraonline.nic.in/home/PDF_Doc/fc_notice_07042025.pdf",
        title:'ANNOUNCEMENTS'
    },
]
export { opportunitiesData }